import { DateTime, Interval } from 'luxon';
import { SegmentsForEdit } from '../wizard/time-slot.types';

export const parseSegmentDateTime = (value: string): DateTime | null => {
  if (!value) {
    return null;
  }

  const fromTimeFormat = DateTime.fromFormat(value, 'T');
  if (fromTimeFormat.isValid) {
    return fromTimeFormat;
  }

  const fromIso = DateTime.fromISO(value);
  return fromIso.isValid ? fromIso : null;
};

const toSegmentInterval = (start: string, end: string): Interval | null => {
  const startDateTime = parseSegmentDateTime(start);
  const endDateTime = parseSegmentDateTime(end);

  if (!startDateTime || !endDateTime) {
    return null;
  }

  const interval = Interval.fromDateTimes(startDateTime, endDateTime);
  return interval.isValid ? interval : null;
};

const intervalsOverlap = (first: Interval, second: Interval): boolean => {
  if (
    first.abutsStart(second) ||
    first.abutsEnd(second) ||
    second.abutsStart(first) ||
    second.abutsEnd(first)
  ) {
    return false;
  }

  return first.overlaps(second);
};

export const isInvalidSegmentRange = (start: string, end: string): boolean => {
  const startDateTime = parseSegmentDateTime(start);
  const endDateTime = parseSegmentDateTime(end);

  if (!startDateTime || !endDateTime) {
    return false;
  }

  return startDateTime >= endDateTime;
};

export const isOverlappingSegment = (
  slot: SegmentsForEdit,
  timeslots: SegmentsForEdit[]
): boolean => {
  const timeSlotInterval = toSegmentInterval(slot.utcStartDateTime, slot.utcEndDateTime);
  if (!timeSlotInterval) {
    return false;
  }

  const overlappingSlot = timeslots.find((existingSlot) => {
    if (slot.segmentId && slot.segmentId === existingSlot.segmentId) {
      return false;
    }

    const existingInterval = toSegmentInterval(
      existingSlot.utcStartDateTime,
      existingSlot.utcEndDateTime
    );
    if (!existingInterval) {
      return false;
    }

    return intervalsOverlap(timeSlotInterval, existingInterval);
  });

  return !!overlappingSlot;
};
